import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { LocalStorageService } from "./local-storage.service";

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
    constructor(private localStorageService: LocalStorageService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentLocale = this.localStorageService.getLocale();

        const localizedRequest = req.clone({
            headers: req.headers.set("Accept-Language", currentLocale),
        });

        return next.handle(localizedRequest);
    }
}
